import { render, staticRenderFns } from "./AntecipacaoProfissionalMock.vue?vue&type=template&id=042fad98&scoped=true"
import script from "./AntecipacaoProfissionalMock.vue?vue&type=script&lang=ts"
export * from "./AntecipacaoProfissionalMock.vue?vue&type=script&lang=ts"
import style0 from "./AntecipacaoProfissionalMock.vue?vue&type=style&index=0&id=042fad98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fad98",
  null
  
)

export default component.exports